export { useRmpLoginStateInterop as default } from '@portal-internet/core';